<template>
  <div class="home mt-2">
    <div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
      <div class="d-flex align-items-center flex-wrap">
        <h2 class="mb-0 mr-3">Usuarios</h2>
      </div>

      <div class="d-flex align-items-center flex-wrap mt-2 mt-sm-0">
        <button
          class="btn btn-sm btn-principal mr-2"
          data-toggle="collapse"
          href="#filtroscollapse"
          role="button"
          aria-expanded="false"
          aria-controls="filtroscollapse"
          @click="cargarFiltros"
        >
          <i class="bi-filter"></i> Filtros
        </button>
        <button
          class="btn btn-sm btn-principal"
          data-toggle="tooltip"
          data-placement="top"
          title="Nuevo Usuario"
          @click="showEdit({}, 'add')"
        >
          <i class="bi-plus"></i> Nuevo Usuario
        </button>
      </div>
    </div>
    <div class="collapse mb-3" id="filtroscollapse">
      <div class="card card-body bg-light border-0 shadow-sm py-3 px-4">
        <div class="form-row align-items-end">
          <div class="form-group col mb-2">
            <label class="font-weight-bold small text-muted mb-1" for="usuario_select">Por Usuario</label>
            <input
              type="text"
              class="form-control"
              id="usuario_select"
              placeholder="Filtrar por usuario..."
              @keyup.enter="usuariosBuscar()"
              v-model="usuario_sel"
              aria-label="Usuario"
            />
          </div>
          <div class="form-group col mb-2">
            <label class="font-weight-bold small text-muted mb-1" for="integrador_select">Por Integrador</label>
            <select
              class="form-control"
              v-model="id_integrador_sel"
              name="atributo"
              aria-label="Atributos"
              id="integrador_select"
            >
              <option selected value>Todos los integradores</option>
              <template v-if="integradoresList && integradoresList.length">
                <option
                  v-for="integrador in integradoresList"
                  v-bind:key="integrador.id_integrador"
                  v-bind:value="integrador.id_integrador"
                >
                  {{ integrador.integrador }}
                </option>
              </template>
            </select>
          </div>
          <div class="form-group col-md-2 mb-2">
            <label class="font-weight-bold small text-muted mb-1" for="rol_select">Por Rol</label>
            <select
              class="form-control"
              v-model="rol_sel"
              name="atributo"
              aria-label="Tipo"
              id="rol_select"
            >
              <option selected value="">Todos los roles</option>
              <option
                v-for="r in roles"
                :key="r.id_rol"
                :value="r.nombre"
              >
                {{ r.descripcion || r.nombre }}
              </option>
            </select>
          </div>
          <div class="form-group col-md-2 mb-2">
            <label class="font-weight-bold small text-muted mb-1" for="enabled_select">Por Estado</label>
            <select
              class="form-control"
              v-model="enabled_sel"
              name="atributo"
              aria-label="Activo"
              id="enabled_select"
            >
              <option selected value>Todos los estados</option>
              <option selected value="0">Inactivo</option>
              <option selected value="1">Activo</option>
            </select>
          </div>
          <div class="form-group col-auto mb-2">
            <button @click="usuariosBuscar()" class="btn btn-info px-4">
              <i class="bi-search"></i> Buscar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="alert alert-success" role="alert" v-if="success">
      {{ success }}
    </div>
    <div class="alert alert-danger" role="alert" v-if="error">{{ error }}</div>
    <table
      class="table xtable-responsive table-striped xtable-fixed table-sm"
      v-if="usuariosBusqueda && usuariosBusqueda.data.length"
    >
      <thead>
        <tr>
          <th
            @click="orderByfield('id_usuario')"
            class="tablesorter-header"
            :class="orderClass('id_usuario')"
            scope="col"
            width="80"
          >
            Id
          </th>
          <th
            @click="orderByfield('name')"
            class="tablesorter-header"
            :class="orderClass('name')"
            scope="col"
          >
            Usuario
          </th>
          <th
            @click="orderByfield('email')"
            class="tablesorter-header"
            :class="orderClass('email')"
            scope="col"
          >
            Email
          </th>
          <th
            @click="orderByfield('integrador')"
            class="tablesorter-header"
            :class="orderClass('integrador')"
            scope="col"
          >
            Integrador
          </th>
          <th
            @click="orderByfield('rol')"
            class="tablesorter-header"
            :class="orderClass('rol')"
            scope="col"
          >
            Rol
          </th>
          <th
            @click="orderByfield('enabled')"
            class="tablesorter-header"
            :class="orderClass('enabled')"
            scope="col"
          >
            Estado
          </th>
          <th scope="col" width="110"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="usuarioItem of usuariosBusqueda.data"
          v-bind:key="usuarioItem.id_usuario"
        >
          <th scope="row">{{ usuarioItem.id_usuario }}</th>
          <td>{{ usuarioItem.name }}</td>
          <td>{{ usuarioItem.email }}</td>
          <td>
            <template
              v-if="
                usuarioItem.integradores && usuarioItem.integradores.length
              "
            >
              <span
                v-for="(integ, idx) in usuarioItem.integradores"
                v-bind:key="integ.id_integrador"
              >
                <span v-if="idx > 0">, </span>{{ integ.integrador }}
              </span>
            </template>
            <template v-else>
              {{ usuarioItem.integrador }}
              <small v-if="usuarioItem.id_integrador"
                >(ID:{{ usuarioItem.id_integrador }})</small
              >
            </template>
          </td>
          <td :class="usuarioItem.rol == 'admin' ? 'text-danger' : ''">
            {{ getRolNombre(usuarioItem.rol) }}
          </td>
          <td>
            <status-badge :value="usuarioItem.enabled" />
          </td>
          <td>
            <nobr>
              <button
                class="btn btn-default btn-sm mr-1 pt-0 pb-1"
                data-toggle="tooltip"
                data-placement="top"
                title="Ver, Generar o Regenerar API Token y API Secret"
                @click="showEdit(usuarioItem, 'token')"
              >
                <small class="bi-recycle"></small>
              </button>
              <button
                class="btn btn-info btn-sm mr-1 pt-0 pb-1"
                data-toggle="tooltip"
                data-placement="top"
                title="Cambiar Password"
                @click="showEdit(usuarioItem, 'password')"
              >
                <small class="bi-key-fill"></small>
              </button>
              <button
                class="btn btn-primary btn-sm mr-1 pt-0 pb-1"
                data-toggle="tooltip"
                data-placement="top"
                title="Editar Usuario"
                @click="showEdit(usuarioItem, 'edit')"
              >
                <small class="bi-pencil-fill"></small>
              </button>
              <button
                class="btn btn-danger btn-sm pt-0 pb-1"
                data-toggle="tooltip"
                data-placement="top"
                :title="
                  usuarioItem.enabled == '1' ? 'Eliminar usuario' : 'Activar'
                "
                @click="showEdit(usuarioItem, 'delete')"
              >
                <small
                  class="bi"
                  :class="
                    usuarioItem.enabled == '1'
                      ? 'bi-trash-fill'
                      : 'bi-arrow-90deg-left'
                  "
                ></small>
              </button>
            </nobr>
          </td>
        </tr>
      </tbody>
    </table>
    <Paginador
      v-if="usuariosBusqueda && usuariosBusqueda.pages"
      :pages="usuariosBusqueda.pages"
      @selPage="changePage"
    ></Paginador>
    <div
      v-if="
        !(
          usuariosBusqueda &&
          usuariosBusqueda.data &&
          usuariosBusqueda.data.length
        ) && post
      "
    >
      <div class="alert alert-info">
        No se obtubieron atributos con el criterio seleccionado.
      </div>
    </div>
    <div v-if="error">{{ error.message }}</div>
    <!-- Modal -->
    <div v-if="showModal">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div
              class="modal-dialog modal-lg"
              :class="operation == 'token' ? '' : 'modal-dialog-scrollable'"
              role="document"
            >
              <div class="modal-content">
                <div class="modal-header">
                  <h5 v-if="operation == 'delete'" class="modal-title">
                    Borrar Usuario
                  </h5>
                  <h5 v-if="operation == 'edit'" class="modal-title">
                    Editar Usuario
                  </h5>
                  <h5 v-if="operation == 'add'" class="modal-title">
                    Nuevo Usuario
                  </h5>
                  <h5 v-if="operation == 'password'" class="modal-title">
                    Cambiar Constraseña
                  </h5>
                  <h5 v-if="operation == 'token'" class="modal-title">
                    <span v-if="editData.apitoken">Regenerar</span>
                    <span v-else>Generar</span> Tokens
                  </h5>

                  <ul
                    v-if="
                      operation == 'delete' ||
                      operation == 'edit' ||
                      operation == 'add'
                    "
                    class="nav nav-tabs"
                    id="modal_title_tabs_users"
                    role="tablist"
                  >
                    <li class="nav-item">
                      <a
                        class="nav-link active"
                        id="user-data-tab"
                        data-toggle="tab"
                        href="#user-data"
                        role="tab"
                        aria-controls="home"
                        aria-selected="true"
                        >Datos</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        id="user-permission-tab"
                        data-toggle="tab"
                        href="#user-permission"
                        role="tab"
                        aria-controls="profile"
                        aria-selected="false"
                        >Permisos</a
                      >
                    </li>
                  </ul>

                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click="closeModal"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div v-if="operation == 'token'">
                                        <p>
                      Al generar los códigos de acceso API Token y API Secret se
                      le permitirá acceder a las APIs detallas en los permisos
                      del usuario. Para que el usuario pueda utilizar las claves
                      debe tener al menos una API habilitada en los permisos.
                    </p>
                    <div
                      v-if="editData.apitoken"
                      class="alert alert-warning d-flex align-items-center"
                      role="alert"
                    >
                      <i class="bi bi-exclamation-triangle-fill mr-3"></i>
                      <div>
                        <b>¡ATENCIÓN!</b> Al regenerar los códios del API Token
                        y API Secret, el usuario
                        <b>no prodrá acceder a las APIs</b> que esté utilizando,
                        hasta que no cambie sus accesos con los nuevos códigos
                        generados.
                      </div>
                    </div>

                    <div
                      v-if="editData.apitoken"
                      class="alert alert-success d-flex align-items-center"
                      role="alert"
                    >
                      <p style="text-align: center;width: 100%;">
                        <b>Api Token: </b> {{ editData.apitoken }}
                        <br />
                        <br />
                        <b>Api Secret: </b>
                        <span v-if="!editData.showSecret"> {{
                          editData.apisecret
                        }} </span>
                        <span v-if="editData.showSecret"
                          > *************************************** 
                        </span>
                        <a
                          class="btn btn-default btn-sm"
                          @click="editData.showSecret = !editData.showSecret"
                        >
                          <i
                            :class="
                              editData.showSecret
                                ? 'bi-eye-slash-fill'
                                : 'bi-eye-fill'
                            "
                            class="bi"
                          ></i>
                        </a>
                      </p>
                    </div>


                  </div>

                  <form
                    v-if="
                      operation == 'delete' ||
                      operation == 'edit' ||
                      operation == 'password' ||
                      operation == 'add'
                    "
                    id="form_user"
                  >
                    <div class="tab-content" id="myTabContent">
                      <div
                        class="tab-pane fade show active"
                        id="user-data"
                        role="tabpanel"
                        aria-labelledby="user-data-tab"
                      >
                        <div
                          v-if="
                            operation == 'delete' ||
                            operation == 'edit' ||
                            operation == 'password'
                          "
                          class="form-group"
                        >
                          <label>Id Usuario</label>
                          <b class="form-control">{{ editData.id_usuario }}</b>
                        </div>

                        <div class="form-group">
                          <label>Usuario</label>
                          <b
                            class="form-control"
                            v-if="
                              operation == 'delete' || operation == 'password'
                            "
                          >
                            {{ editData.name }}
                          </b>
                          <input
                            :class="
                              errors && errors.errors && errors.errors.name
                                ? 'is-invalid'
                                : ''
                            "
                            class="form-control"
                            v-if="operation == 'edit' || operation == 'add'"
                            type="text"
                            placeholder="Ej: juan.perez"
                            v-model="editData.name"
                          />
                          <small class="form-text text-muted" v-if="operation == 'edit' || operation == 'add'">Nombre de usuario para inicio de sesión (alfanumérico sin espacios).</small>
                          <div
                            v-if="errors && errors.errors && errors.errors.name"
                            class="invalid-feedback"
                          >
                            <template v-for="errorItem of errors.errors.name">
                              {{ errorItem }}
                            </template>
                          </div>
                        </div>

                        <div class="form-group">
                          <label
                            v-if="
                              operation == 'delete' ||
                              operation == 'edit' ||
                              operation == 'add'
                            "
                            >Email</label
                          >
                          <b class="form-control" v-if="operation == 'delete'">
                            {{ editData.email ? editData.email : "\xa0" }}
                          </b>
                          <input
                            class="form-control"
                            :class="
                              errors && errors.errors && errors.errors.email
                                ? 'is-invalid'
                                : ''
                            "
                            v-if="operation == 'edit' || operation == 'add'"
                            type="email"
                            placeholder="Ej: usuario@empresa.com"
                            v-model="editData.email"
                          />
                          <small class="form-text text-muted" v-if="operation == 'edit' || operation == 'add'">Dirección de correo electrónico válida para notificaciones.</small>
                          <div
                            v-if="
                              errors && errors.errors && errors.errors.email
                            "
                            class="invalid-feedback"
                          >
                            <template v-for="errorItem of errors.errors.email">
                              {{ errorItem }}
                            </template>
                          </div>
                        </div>

                        <div
                          v-if="operation == 'add' || operation == 'password'"
                          class="form-group"
                        >
                          <label>Contraseña</label>
                          <div class="input-group">
                            <input
        class="form-control"
        :class="{
          'is-invalid': errors && errors.password,
          'is-valid': passwordStrength && passwordStrength.isValid
        }"
        :type="editData.passwordFieldType"
        placeholder="Mínimo 8 caracteres"
        v-model="editData.password"
        @input="checkPasswordStrength"
      />

                            <div class="input-group-append">
                              <button
                                title="Mostrar u ocultar el password"
                                class="btn btn-outline-secondary"
                                type="button"
                                @click="
                                  editData.passwordFieldType =
                                    editData.passwordFieldType === 'password'
                                      ? 'text'
                                      : 'password'
                                "
                              >
                                <i
                                  :class="
                                    editData.passwordFieldType === 'text'
                                      ? ' bi-eye-slash-fill'
                                      : ' bi-eye-fill'
                                  "
                                ></i>
                              </button>
                            </div>
                            <div
                              v-if="
                                errors &&
                                errors.errors &&
                                errors.errors.password
                              "
                              class="invalid-feedback"
                            >
                              <template
                                v-for="errorItem of errors.errors.password"
                              >
                                {{ errorItem }}
                              </template>
                            </div>
                          </div>
                          <small class="form-text text-muted">La contraseña debe tener al menos 8 caracteres, incluyendo letras y números.</small>
 <div v-if="passwordStrength" class="password-strength mt-2">
        <div :class="{'text-danger': !passwordStrength.isValid, 'text-success': passwordStrength.isValid}">
          {{ passwordStrength.message }}
        </div>
      </div>
                          <label>Repetir Contraseña</label>
                          <div class="input-group">
                            <input
                              class="form-control"
                              :class="
                                errors &&
                                errors.errors &&
                                errors.errors.password_confirmation
                                  ? 'is-invalid'
                                  : ''
                              "
                              :type="editData.passwordFieldType"
                              placeholder="Repita la contraseña"
                              v-model="editData.password_confirmation"
                            />
                            <div
                              v-if="
                                errors &&
                                errors.errors &&
                                errors.errors.password_confirmation
                              "
                              class="invalid-feedback"
                            >
                              <template
                                v-for="errorItem of errors.errors
                                  .password_confirmation"
                              >
                                {{ errorItem }}
                              </template>
                            </div>
                          </div>
                          <small class="form-text text-muted">Confirme la misma contraseña ingresada arriba.</small>
                        </div>

                        <!-- Selección de Integradores (Edición y Alta) -->
                        <div
                          v-if="operation == 'edit' || operation == 'add'"
                          class="form-group"
                        >
                          <div
                            class="d-flex justify-content-between align-items-center mb-1"
                          >
                            <label class="font-weight-bold mb-0">Integradores</label>
                            <span
                              class="badge badge-info"
                              v-if="editData.id_integradores && editData.id_integradores.length"
                            >
                              {{ editData.id_integradores.length }} seleccionado(s)
                            </span>
                          </div>

                          <div
                            class="input-group input-group-sm mb-2"
                            v-if="todosIntegradores && todosIntegradores.length > 5"
                          >
                            <div class="input-group-prepend">
                              <span class="input-group-text"><i class="bi bi-search"></i></span>
                            </div>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Buscar integrador..."
                              v-model="filtroTextoIntegrador"
                            />
                            <div
                              class="input-group-append"
                              v-if="filtroTextoIntegrador"
                            >
                              <button
                                class="btn btn-outline-secondary"
                                type="button"
                                @click="filtroTextoIntegrador = ''"
                              >
                                &times;
                              </button>
                            </div>
                          </div>

                          <div
                            class="border rounded p-2 bg-white"
                            style="max-height: 180px; overflow-y: auto;"
                          >
                            <div
                              class="form-check mb-1"
                              v-for="integrador in integradoresFiltrados"
                              v-bind:key="integrador.id_integrador"
                            >
                              <input
                                :value="integrador.id_integrador"
                                v-model="editData.id_integradores"
                                type="checkbox"
                                class="form-check-input"
                                :id="'editInt' + integrador.id_integrador"
                              />
                              <label
                                class="form-check-label"
                                :for="'editInt' + integrador.id_integrador"
                              >
                                {{ integrador.integrador }}
                                <small class="text-muted">(ID: {{ integrador.id_integrador }})</small>
                                <small
                                  v-if="integrador.activo == 0"
                                  class="text-muted"
                                  >(inactivo)</small
                                >
                              </label>
                            </div>
                            <div
                              v-if="!integradoresFiltrados.length"
                              class="text-muted small"
                            >
                              {{
                                todosIntegradores.length
                                  ? "No hay integradores que coincidan con la búsqueda."
                                  : "No hay integradores disponibles."
                              }}
                            </div>
                          </div>
                          <small class="form-text text-muted"
                            >Empresas o integradores a los que pertenece la
                            cuenta. Puede seleccionar varios.</small
                          >
                        </div>

                        <div v-if="operation == 'delete'" class="form-group">
                          <label>Integradores</label>
                          <b class="form-control">
                            <template
                              v-if="
                                editData.integradores &&
                                editData.integradores.length
                              "
                            >
                              <span
                                v-for="(integ, idx) in editData.integradores"
                                v-bind:key="integ.id_integrador"
                              >
                                <span v-if="idx > 0">, </span>{{ integ.integrador }}
                              </span>
                            </template>
                            <template v-else>
                              {{ editData.id_integrador
                              }}{{ editData.integrador ? "-" : "\xa0"
                              }}{{ editData.integrador }}
                            </template>
                          </b>
                        </div>

                        <div v-if="operation == 'delete'" class="form-group">
                          <label>
                            <i
                              class="bi"
                              :class="
                                editData.enabled == 1
                                  ? 'bi-check-square'
                                  : 'bi-square'
                              "
                            ></i>
                            Activo</label
                          >
                        </div>

                        <div
                          v-if="operation == 'edit' || operation == 'add'"
                          class="form-check"
                        >
                          <input
                            v-model="editData.enabled"
                            true-value="1"
                            false-value="0"
                            type="checkbox"
                            class="form-check-input"
                            id="exampleCheck2"
                          />
                          <label class="form-check-label" for="exampleCheck2"
                            >Activo</label
                          >
                        </div>
                      </div>

                      <div
                        class="tab-pane fade xml-5"
                        id="user-permission"
                        role="tabpanel"
                        aria-labelledby="user-permission-tab"
                      >
                        <div class="form-group mb-3">
                          <label for="rol_select" class="font-weight-bold">Rol</label>
                          <select
                            v-if="operation == 'edit' || operation == 'add'"
                            class="form-control"
                            v-model="editData.rol"
                            @change="onRolChange"
                            name="atributo"
                            aria-label="Tipo"
                            id="rol_select"
                          >
                            <option
                              v-for="r in roles"
                              :key="r.id_rol"
                              :value="r.nombre"
                            >
                              {{ r.descripcion || r.nombre }}
                            </option>
                          </select>
                          <b class="form-control" v-if="operation == 'delete'">
                            {{ getRolNombre(editData.rol) }}
                          </b>
                          <small class="form-text text-muted" v-if="operation == 'edit' || operation == 'add'">
                            Al cambiar el rol, se muestran y seleccionan únicamente los permisos permitidos para dicho rol.
                          </small>
                        </div>
                        <!-- Árbol de Permisos: Aplicación -> Permiso -->
                        <div class="permissions-tree border rounded p-2 bg-white" style="max-height: 400px; overflow-y: auto;">
                          <div
                            v-if="!arbolPermisos || !arbolPermisos.length"
                            class="text-muted small text-center py-4"
                          >
                            <i class="bi bi-info-circle mr-1"></i> No se encontraron permisos.
                          </div>

                          <div
                            v-for="app in arbolPermisos"
                            :key="'app_' + app.nombre"
                            class="tree-app-node mb-2"
                          >
                            <!-- Nivel 1: Aplicación (Sin checkbox en el título) -->
                            <div
                              class="d-flex align-items-center justify-content-between p-2 rounded bg-light border tree-header-app"
                              @click="toggleNode('app_' + app.nombre)"
                            >
                              <div class="d-flex align-items-center">
                                <button
                                  type="button"
                                  class="btn btn-link btn-sm text-secondary p-0 mr-2"
                                  @click.stop="toggleNode('app_' + app.nombre)"
                                >
                                  <i
                                    class="bi"
                                    :class="isNodeExpanded('app_' + app.nombre) ? 'bi-chevron-down' : 'bi-chevron-right'"
                                  ></i>
                                </button>

                                <span class="font-weight-bold text-dark">
                                  <i class="bi bi-layers-fill text-primary mr-1"></i>
                                  {{ app.nombre }}
                                </span>
                              </div>

                              <div>
                                <span class="badge badge-pill badge-primary">
                                  {{ getAppSelectedCount(app) }} / {{ app.permisos.length }}
                                </span>
                              </div>
                            </div>

                            <!-- Nivel 2: Permisos dentro de la Aplicación -->
                            <div
                              v-show="isNodeExpanded('app_' + app.nombre)"
                              class="tree-children-app pl-4 pr-2 py-1"
                            >
                              <div
                                v-for="permiso in app.permisos"
                                :key="'perm_' + app.nombre + '_' + permiso.nombre"
                                class="tree-permiso-leaf d-flex align-items-center py-1"
                              >
                                <div
                                  v-if="operation == 'edit' || operation == 'add'"
                                  class="custom-control custom-checkbox mr-2"
                                >
                                  <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    :id="'perm_' + app.nombre + '_' + permiso.nombre"
                                    :value="permiso.nombre"
                                    v-model="editData.permisosSeleccionados"
                                  />
                                  <label
                                    class="custom-control-label small"
                                    :for="'perm_' + app.nombre + '_' + permiso.nombre"
                                  >
                                    <span class="font-weight-bold">{{ permiso.descripcion }}</span>
                                  </label>
                                </div>
                                <div v-else class="d-flex align-items-center small">
                                  <i
                                    class="bi mr-2"
                                    :class="isPermisoSeleccionado(permiso.nombre) ? 'bi-check-square-fill text-success' : 'bi-square text-muted'"
                                  ></i>
                                  <span class="font-weight-bold">{{ permiso.descripcion }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                  <div
                    v-if="errors"
                    class="alert alert-danger my-2"
                    role="alert"
                  >
                    <i class="bi bi-exclamation-triangle me-1"></i>
                    {{ typeof errors === 'object' ? (errors.error ? (errors.error.message || errors.error) : (errors.message || JSON.stringify(errors))) : errors }}
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    @click="closeModal"
                  >

                    Cancelar
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'password'"
                    @click="passwordUsuario"
                    class="btn btn-primary"
                  >
                    Guardar
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'delete'"
                    @click="deleteUsuario"
                    class="btn btn-primary"
                  >
                    <span v-if="editData.enabled == '1'">Borrar</span>
                    <span v-else>Activar</span>
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'edit'"
                    @click="editUsuario"
                    class="btn btn-primary"
                  >
                    Guardar
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'add'"
                    @click="agregarUsuario"
                    class="btn btn-primary"
                  >
                    Guardar
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'token'"
                    @click="genTokensUsuario"
                    class="btn btn-primary"
                  >
                    <span v-if="editData.apitoken">Regenerar</span>
                    <span v-else>Generar</span> Tokens
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Paginador from "./Paginador.vue";
import StatusBadge from "./utiles/StatusBadge.vue";
import { tableSortMixin } from "@/mixins/tableSortMixin";
export default {
  name: "Usuarios",
  mixins: [tableSortMixin],

  data() {
    return {
      success: null,
      error: null,
      enabled_sel: "",
      rol_sel: "",
      id_integrador_sel: "",
      usuario_sel: null,
      usuariosBusqueda: null,
      post: false,
      showModal: false,
      editData: null,
      operation: null,
      orderByField: "name",
      page: 1,
      errors: [],
      pages: null,
      permisosAgrupados: {
        api: [],
        genesis: [],
      },
      passwordStrength: null,
      roles: [],
      permisos: [],
      rolPermisos: [],
      todosIntegradores: [],
      filtroTextoPermiso: "",
      filtroTextoIntegrador: "",
      nodosExpandidos: {},
    };
  },

  components: {
    Paginador,
    StatusBadge,
  },

  created() {
    this.fetchRoles();
    this.fetchPermisos();
    if (this.isAdmin()) {
      this.fetchIntegradores();
      this.fetchTodosIntegradores();
    }
    this.getUsuariosBusqueda();
  },

  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters("integrador", ["integradores"]),

    integradoresList() {
      let list = [];
      if (this.integradores && this.integradores.data && this.integradores.data.length > 0) {
        list = [...this.integradores.data];
      } else if (this.user && this.user.integradores && Array.isArray(this.user.integradores)) {
        list = [...this.user.integradores];
      }
      return list.sort((a, b) =>
        String(a.integrador || "").localeCompare(String(b.integrador || ""), undefined, { sensitivity: "base" })
      );
    },

    integradoresFiltrados() {
      if (!this.todosIntegradores || !Array.isArray(this.todosIntegradores)) {
        return [];
      }
      const list = [...this.todosIntegradores].sort((a, b) =>
        String(a.integrador || "").localeCompare(String(b.integrador || ""), undefined, { sensitivity: "base" })
      );
      if (!this.filtroTextoIntegrador || !this.filtroTextoIntegrador.trim()) {
        return list;
      }
      const term = this.filtroTextoIntegrador.trim().toLowerCase();
      return list.filter((item) => {
        const id = String(item.id_integrador || "");
        const nombre = String(item.integrador || "").toLowerCase();
        return id.includes(term) || nombre.includes(term);
      });
    },

    arbolPermisos() {
      const appsMap = {};
      const currentRol = this.editData && (this.editData.rol || this.editData.id_rol);

      let roleId = null;
      let roleName = null;
      if (currentRol) {
        const cleanRol = String(currentRol).trim().toLowerCase();
        roleName = cleanRol;
        if (this.roles && this.roles.length) {
          const foundRole = this.roles.find(
            (r) =>
              String(r.nombre).toLowerCase() === cleanRol ||
              String(r.id_rol) === cleanRol ||
              (r.descripcion && String(r.descripcion).toLowerCase() === cleanRol)
          );
          if (foundRole) {
            roleId = String(foundRole.id_rol);
            roleName = String(foundRole.nombre).toLowerCase();
          }
        }
      }

      // Filtrar sólo los permisos permitidos para el rol según la tabla permisos roles (rol_permisos)
      let sourceList = [];
      if (this.rolPermisos && this.rolPermisos.length > 0) {
        sourceList = this.rolPermisos
          .filter((rp) => {
            if (!currentRol) return true;
            const rpName = String(rp.rol_nombre || "").trim().toLowerCase();
            const rpId = String(rp.id_rol || "");
            if (roleId && rpId === roleId) return true;
            if (roleName && rpName === roleName) return true;
            const cleanRol = String(currentRol).trim().toLowerCase();
            if (rpName === cleanRol || rpId === cleanRol) return true;
            return false;
          })
          .map((rp) => ({
            id_permiso: rp.id_permiso,
            nombre: rp.permiso_nombre || rp.nombre,
            descripcion: rp.permiso_descripcion || rp.descripcion || rp.permiso_nombre || rp.nombre,
            aplicacion: rp.aplicacion || this.getAplicacionDePermiso(rp),
          }));
      } else if (this.permisos && this.permisos.length > 0 && (!currentRol || roleName === "admin")) {
        sourceList = this.permisos;
      }

      sourceList.forEach((p) => {
        const nom = this.getPermisoNombre(p);
        if (!nom) return;
        const app = this.getAplicacionDePermiso(p);
        if (!appsMap[app]) {
          appsMap[app] = {
            nombre: app,
            permisos: [],
          };
        }
        if (!appsMap[app].permisos.some((x) => x.nombre === nom)) {
          appsMap[app].permisos.push({
            id_permiso: p.id_permiso,
            nombre: nom,
            descripcion: p.descripcion || p.permiso_descripcion || nom,
            aplicacion: app,
          });
        }
      });

      const appKeys = Object.keys(appsMap).sort();
      return appKeys.map((appKey) => {
        const appObj = appsMap[appKey];
        appObj.permisos.sort((a, b) => a.nombre.localeCompare(b.nombre));
        return appObj;
      });
    },

    arbolPermisosCompleto() {
      return this.arbolPermisos;
    },

    arbolPermisosFiltrado() {
      return this.arbolPermisos;
    },
  },

  filters: {
    uppercase: function (v) {
      return v.toUpperCase();
    },
    capitalize: function (v) {
      return v.toLowerCase().replace(/\b\w/g, (l) => l.toUpperCase());
    },
  },

  mounted() {
    this.fetchPermisos();
  },

  methods: {
    ...mapActions("integrador", ["fetchIntegradores"]),

    isAdmin() {
      return this.user && this.user.rol == "admin";
    },

    cargarFiltros: function () {
      this.fetchRoles();
      this.fetchPermisos();
      this.fetchTodosIntegradores();
      if (this.isAdmin()) {
        this.fetchIntegradores();
      }
      return Promise.resolve(null);
    },

    fetchTodosIntegradores: function () {
      return axios
        .post(process.env.VUE_APP_API_URL + "integrador/all")
        .then((response) => {
          if (response && response.data && Array.isArray(response.data.data)) {
            const list = [...response.data.data];
            list.sort((a, b) =>
              String(a.integrador || "").localeCompare(String(b.integrador || ""), undefined, { sensitivity: "base" })
            );
            this.todosIntegradores = list;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    fetchRoles: function () {
      return axios
        .post(process.env.VUE_APP_API_URL + "usuario/roles")
        .then((response) => {
          if (response && response.data && response.data.data) {
            this.roles = response.data.data;
            if (this.editData) {
              this.normalizeEditRol();
              this.tryInitPermisosSeleccionados();
            }
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    fetchPermisos: function () {
      return axios
        .post(process.env.VUE_APP_API_URL + "usuario/permisos")
        .then((response) => {
          if (response && response.data) {
            this.permisos = response.data.data || [];
            this.rolPermisos = response.data.rol_permisos || [];
            if (response.data.grouped) {
              this.permisosAgrupados = response.data.grouped;
            } else if (response.data.data) {
              const grouped = {};
              response.data.data.forEach((p) => {
                const app = this.getAplicacionDePermiso(p).toLowerCase();
                if (!grouped[app]) grouped[app] = [];
                grouped[app].push(p);
              });
              this.permisosAgrupados = grouped;
            }
          }
          this.tryInitPermisosSeleccionados();
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    buildPermisosSeleccionados: function () {
      if (!this.editData) return [];
      let selected = [];
      let permissions = this.editData.permissions;
      if (permissions && typeof permissions === "string") {
        try {
          permissions = JSON.parse(permissions);
        } catch (e) {
          permissions = null;
        }
      }
      if (permissions && typeof permissions === "object") {
        Object.keys(permissions).forEach((g) => {
          if (g === "admin") return;
          if (Array.isArray(permissions[g])) {
            permissions[g].forEach((n) => {
              if (n) selected.push(String(n).trim().toUpperCase());
            });
          }
        });
      }

      const roleVal = this.editData.rol || this.editData.id_rol;
      const allowed = this.getPermisosDeRol(roleVal);

      const isAdmin =
        String(roleVal).trim().toLowerCase() === "admin" ||
        (permissions && permissions.admin === true);

      if (isAdmin && (!selected.length || (permissions && permissions.admin === true))) {
        selected = allowed.length
          ? [...allowed]
          : (this.permisos || []).map((p) => this.getPermisoNombre(p)).filter(Boolean);
      } else if (!selected.length && roleVal) {
        selected = [...allowed];
      } else if (allowed.length) {
        selected = selected.filter((p) => allowed.includes(p));
      }

      return [...new Set(selected)];
    },

    tryInitPermisosSeleccionados: function () {
      if (!this.editData) return;
      const loaded =
        (this.rolPermisos && this.rolPermisos.length > 0) ||
        (this.permisos && this.permisos.length > 0);
      if (!loaded) return;
      if (
        !this.editData._permisosInicializado ||
        !this.editData.permisosSeleccionados ||
        !this.editData.permisosSeleccionados.length
      ) {
        this.$set(this.editData, "_permisosInicializado", true);
        this.$set(
          this.editData,
          "permisosSeleccionados",
          this.buildPermisosSeleccionados()
        );
      }
    },

    getPermisoNombre: function (item) {
      if (!item) return "";
      return typeof item === "object" && item.nombre ? item.nombre : String(item);
    },

    getPermisoDescripcion: function (item) {
      if (!item || typeof item !== "object") return "";
      return item.descripcion || "";
    },

    getAplicacionDePermiso: function (p) {
      if (p && p.aplicacion && String(p.aplicacion).trim()) {
        return String(p.aplicacion).trim().toUpperCase();
      }
      const nombre = String(
        (p && (p.permiso_nombre || p.nombre)) || ""
      ).trim().toUpperCase();
      if (nombre.startsWith("API_")) return "API";
      if (nombre.startsWith("GEN_")) return "GENESIS";
      return nombre.length >= 3 ? nombre.substring(0, 3) : "GENERAL";
    },

    getPermisosDeRol: function (rolVal) {
      if (!rolVal) return [];
      const clean = String(rolVal).trim().toLowerCase();
      let roleId = null;
      let roleName = clean;

      if (this.roles && this.roles.length) {
        const foundRole = this.roles.find(
          (r) =>
            String(r.nombre).toLowerCase() === clean ||
            String(r.id_rol) === clean ||
            (r.descripcion && String(r.descripcion).toLowerCase() === clean)
        );
        if (foundRole) {
          roleId = String(foundRole.id_rol);
          roleName = String(foundRole.nombre).toLowerCase();
        }
      }

      const perms = [];
      if (this.rolPermisos && this.rolPermisos.length > 0) {
        this.rolPermisos.forEach((rp) => {
          const rName = String(rp.rol_nombre || "").trim().toLowerCase();
          const rId = String(rp.id_rol || "");
          if (
            (roleId && rId === roleId) ||
            (roleName && rName === roleName) ||
            rName === clean ||
            rId === clean
          ) {
            const pNom = rp.permiso_nombre || rp.nombre;
            if (pNom && !perms.includes(pNom)) {
              perms.push(pNom);
            }
          }
        });
      }
      if (
        !perms.length &&
        (clean === "admin" || roleName === "admin") &&
        this.permisos &&
        this.permisos.length
      ) {
        return this.permisos.map((p) => this.getPermisoNombre(p)).filter(Boolean);
      }
      return perms;
    },

    onRolChange: function () {
      if (!this.editData || !this.editData.rol) return;
      const nuevoRol = this.editData.rol;
      const permsRol = this.getPermisosDeRol(nuevoRol);
      this.$set(this.editData, "permisosSeleccionados", [...permsRol]);
      this.$nextTick(() => {
        this.arbolPermisos.forEach((app) => {
          this.$set(this.nodosExpandidos, "app_" + app.nombre, true);
        });
      });
    },

    isPermisoSeleccionado: function (permisoNombre) {
      if (!this.editData) return false;
      const selected = this.editData.permisosSeleccionados;
      if (Array.isArray(selected)) {
        return selected.includes(permisoNombre);
      }
      return false;
    },

    getAppSelectedCount: function (app) {
      if (!app || !app.permisos) return 0;
      const selected =
        this.editData && this.editData.permisosSeleccionados
          ? this.editData.permisosSeleccionados
          : [];
      return app.permisos.filter((p) => selected.includes(p.nombre)).length;
    },

    seleccionarTodosVisibles: function () {
      if (!this.editData) return;
      const all = [];
      this.arbolPermisos.forEach((app) => {
        (app.permisos || []).forEach((p) => {
          if (p.nombre && !all.includes(p.nombre)) all.push(p.nombre);
        });
      });
      this.$set(this.editData, "permisosSeleccionados", all);
    },

    deseleccionarTodosVisibles: function () {
      if (!this.editData) return;
      this.$set(this.editData, "permisosSeleccionados", []);
    },

    isNodeExpanded: function (nodeKey) {
      return this.nodosExpandidos[nodeKey] !== false;
    },

    toggleNode: function (nodeKey) {
      const current = this.isNodeExpanded(nodeKey);
      this.$set(this.nodosExpandidos, nodeKey, !current);
    },

    expandirTodo: function () {
      const newMap = {};
      this.arbolPermisos.forEach((app) => {
        newMap["app_" + app.nombre] = true;
      });
      this.nodosExpandidos = newMap;
    },

    colapsarTodo: function () {
      const newMap = {};
      this.arbolPermisos.forEach((app) => {
        newMap["app_" + app.nombre] = false;
      });
      this.nodosExpandidos = newMap;
    },

    getRolNombre: function (rolVal) {
      if (!rolVal) return "-";
      if (this.roles && this.roles.length) {
        const found = this.roles.find(
          (r) => r.nombre === rolVal || String(r.id_rol) === String(rolVal)
        );
        if (found) {
          return found.descripcion || found.nombre;
        }
      }
      if (rolVal === "admin") return "Administrador";
      if (rolVal === "integrador") return "Integrador";
      return rolVal;
    },

    normalizeEditRol: function () {
      if (!this.editData) return;
      let currentRol = this.editData.rol || this.editData.id_rol;
      if (currentRol && this.roles && this.roles.length) {
        const found = this.roles.find(
          (r) => r.nombre === currentRol || String(r.id_rol) === String(currentRol)
        );
        if (found) {
          this.$set(this.editData, "rol", found.nombre);
          return;
        }
      }
      if (!this.editData.rol) {
        this.$set(this.editData, "rol", "publica");
      }
    },

    checkPrermissionEnabled: function (user, group, item) {
      if (!user || !user.permissions) return false;
      let permisions;
      try {
        permisions =
          typeof user.permissions === "string"
            ? JSON.parse(user.permissions)
            : user.permissions;
      } catch (e) {
        return false;
      }

      const itemName = this.getPermisoNombre(item);
      const itemLower = String(itemName).trim().toLowerCase();
      const groupLower = String(group).trim().toLowerCase();

      // Caso 1: permisions es un Objeto agrupado { genesis: [...], api: [...] }
      if (typeof permisions === "object" && permisions !== null && !Array.isArray(permisions)) {
        if (user.rol === "admin" && (permisions.admin === true || permisions["*"] || permisions[group] === "*")) {
          return true;
        }

        const groupList = permisions[group] || permisions[groupLower];
        if (Array.isArray(groupList)) {
          const cleanedGroup = groupList.map((d) => String(d).trim().toLowerCase());
          if (cleanedGroup.includes("*") || cleanedGroup.includes("all")) {
            return true;
          }
          if (cleanedGroup.includes(itemLower)) {
            return true;
          }
        } else if (groupList === true || groupList === "*" || groupList === "all") {
          return true;
        }
      }

      // Caso 2: permisions es un Array plano (ej: ['GEN_PRODUCTO', 'API_TOKEN', ...])
      if (Array.isArray(permisions)) {
        const cleaned = permisions.map((p) => String(p).trim().toLowerCase());
        if (cleaned.includes("*") || cleaned.includes("all")) {
          return true;
        }
        if (cleaned.includes(itemLower)) {
          return true;
        }
      }

      return false;
    },

    usuariosBuscar: function () {
      this.changePage(1);
    },

    aprobacionClass: function (estado) {
      return estado == "APROBADO"
        ? "text-success"
        : estado == "PENDIENTE"
        ? "text-warning"
        : "text-danger";
    },

    changePage: function (page) {
      this.page = page;
      this.getUsuariosBusqueda(false);
    },




    orderByfield: function (field) {
      this.toggleOrder(field);
      this.getUsuariosBusqueda(false);
    },

    getUsuariosBusqueda: function (hideResult = true) {
      if (hideResult) this.usuariosBusqueda = null;
      this.post = false;
      this.$store.commit("setLoading", true);
      return axios
        .post(process.env.VUE_APP_API_URL + "usuario/busqueda", {

          page: this.page,
          id_integrador: this.id_integrador_sel,
          rol: this.rol_sel,
          name: this.usuario_sel,
          enabled: this.enabled_sel,
          order_by: [{ name: this.orderByField, order: this.orderByDirection }],
        })
        .then((response) => {
          response.data.data.forEach((item) => {
            item.showSecret = true;
            item.showApiToken = false;
          });

          this.usuariosBusqueda = response.data;
          if (this.showModal && this.operation === "token" && this.editData) {
            const uItem = response.data.data.find(
              (u) => u.id_usuario === this.editData.id_usuario
            );
            if (uItem) {
              if (uItem.apitoken) {
                this.$set(this.editData, "apitoken", uItem.apitoken);
                this.$set(this.editData, "api_token", uItem.apitoken);
              }
              if (uItem.apisecret) {
                this.$set(this.editData, "apisecret", uItem.apisecret);
                this.$set(this.editData, "api_secret", uItem.apisecret);
              }
            }
          }
        })
        .catch((e) => {
          this.errors.push(e);
           if (e.response.status==429) {
          Swal.fire({
            title: "Error!",
            text: "Espere un momento y vuelva a intentarlo.",
            icon: "error",
            confirmButtonText: "Aceptar",
          });
          }else{
          Swal.fire({
            title: "Error!",
            text: "Ha ocurrido un error al buscar los usuarios",
            icon: "error",
            confirmButtonText: "Aceptar",
          });}
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },

    deleteUsuario: function () {
      this.errors = null;
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "usuario/delete", {
          id_usuario: this.editData.id_usuario,
          enabled: this.editData.enabled == "1" ? "0" : "1",
        })
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar eliminar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getUsuariosBusqueda();
        });
    },

    getPermisions() {
      const selected =
        (this.editData && this.editData.permisosSeleccionados) || [];
      const permissions = {};
      const permisosMap = {};
      (this.permisos || []).forEach((p) => {
        const nom = this.getPermisoNombre(p).toUpperCase();
        permisosMap[nom] = this.getAplicacionDePermiso(p).toLowerCase();
      });
      (this.rolPermisos || []).forEach((rp) => {
        const nom = (rp.permiso_nombre || rp.nombre || "").toUpperCase();
        if (nom && !permisosMap[nom]) {
          permisosMap[nom] = this.getAplicacionDePermiso(rp).toLowerCase();
        }
      });

      selected.forEach((name) => {
        if (!name) return;
        const upper = String(name).trim().toUpperCase();
        const app = permisosMap[upper] || (upper.startsWith("API_") ? "api" : "genesis");
        if (!permissions[app]) {
          permissions[app] = [];
        }
        if (!permissions[app].includes(upper)) {
          permissions[app].push(upper);
        }
      });

      return JSON.stringify(permissions);
    },

    editUsuario: function () {
      this.errors = null;
      this.$store.commit("setLoading", true);

      this.editData.permissions = this.getPermisions();
      this.editData.id_integrador = null;

      axios
        .post(process.env.VUE_APP_API_URL + "usuario/update", this.editData)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data;
          } else {
            Swal.fire({
              title: "Bien!",
              text: "Usuario actualizado correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getUsuariosBusqueda();
        });
    },

    showEdit: function (item, operation) {
      this.cargarFiltros();
      this.errors = null;
      this.editData = Object.assign({ passwordFieldType: "password" }, item);
      this.filtroTextoPermiso = "";
      this.filtroTextoIntegrador = "";
      this.nodosExpandidos = {};

      let integradoresSel = [];
      if (item && Array.isArray(item.integradores)) {
        integradoresSel = item.integradores
          .map((i) => i.id_integrador)
          .filter(Boolean);
      } else if (item && item.id_integrador) {
        integradoresSel = [item.id_integrador];
      }
      this.$set(this.editData, "id_integradores", integradoresSel);
      this.$set(this.editData, "permisosSeleccionados", []);
      this.$set(this.editData, "_permisosInicializado", false);

      if (operation == "add") {
        this.editData.enabled = 1;
        this.$set(this.editData, "rol", "publica");
      } else {
        this.normalizeEditRol();
      }
      this.tryInitPermisosSeleccionados();

      this.$nextTick(() => {
        this.arbolPermisos.forEach((app) => {
          this.$set(this.nodosExpandidos, "app_" + app.nombre, true);
        });
      });

      if (
        operation == "token" &&
        !this.editData.id_integradores &&
        !this.editData.id_integrador
      ) {
        Swal.fire({
          title: "Error!",
          text: "Debe asignar al menos un integrador al usuario para generar los códigos para acceder a las APIs",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
        return false;
      }
      this.showModal = true;
      this.operation = operation;
    },

    agregarUsuario: function () {
      this.errors = null;
      this.$store.commit("setLoading", true);
      this.editData.permissions = this.getPermisions();
      this.editData.id_integrador = null;
      axios
        .post(process.env.VUE_APP_API_URL + "usuario/new", this.editData)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data;
          } else {
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getUsuariosBusqueda();
        });
    },

    genTokensUsuario: function () {
      this.errors = null;
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "usuario/gentokens", {
          id_usuario: this.editData.id_usuario,
        })
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data;
          } else {
            const newToken =
              response.data.apitoken ||
              (response.data.data && response.data.data.apitoken);
            const newSecret =
              response.data.apisecret ||
              (response.data.data && response.data.data.apisecret);

            if (newToken) {
              this.$set(this.editData, "apitoken", newToken);
              this.$set(this.editData, "api_token", newToken);
            }
            if (newSecret) {
              this.$set(this.editData, "apisecret", newSecret);
              this.$set(this.editData, "api_secret", newSecret);
            }
            this.$set(this.editData, "showSecret", false);

            if (
              this.usuariosBusqueda &&
              Array.isArray(this.usuariosBusqueda.data)
            ) {
              const uItem = this.usuariosBusqueda.data.find(
                (u) => u.id_usuario === this.editData.id_usuario
              );
              if (uItem) {
                if (newToken) {
                  uItem.apitoken = newToken;
                  uItem.api_token = newToken;
                }
                if (newSecret) {
                  uItem.apisecret = newSecret;
                  uItem.api_secret = newSecret;
                }
              }
            }

            Swal.fire({
              title: "¡Tokens generados!",
              text: "Los códigos de acceso API Token y API Secret se han generado con éxito.",
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            });

            this.getUsuariosBusqueda(false);
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar generar tokens",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
        });
    },

      togglePasswordVisibility() {
      this.editData.passwordFieldType =
        this.editData.passwordFieldType === 'password' ? 'text' : 'password';
    },


        checkPasswordStrength() {
      const password = this.editData.password;
      const minLength = 8;
      const hasUpperCase = /[A-Z]/.test(password);
      const hasLowerCase = /[a-z]/.test(password);
      const hasNumbers = /[0-9]/.test(password);
      const hasSpecialChars = /[!@#$%^&*(),.?":{}|<>]/.test(password);

      // Condiciones de validación
      const isValid =
        password.length >= minLength &&
        hasUpperCase &&
        hasLowerCase &&
        hasNumbers &&
        hasSpecialChars;

      // Mensaje de la complejidad
      let message = '';
      if (!password) {
        message = 'La contraseña es obligatoria.';
      } else if (!hasUpperCase) {
        message = 'Debe contener al menos una letra mayúscula.';
      } else if (!hasLowerCase) {
        message = 'Debe contener al menos una letra minúscula.';
      } else if (!hasNumbers) {
        message = 'Debe contener al menos un número.';
      } else if (!hasSpecialChars) {
        message = 'Debe contener al menos un carácter especial.';
      } else if (password.length < minLength) {
        message = `La contraseña debe tener al menos ${minLength} caracteres.`;
      } else {
        message = 'Contraseña segura';
      }

      this.passwordStrength = {
        isValid,
        message,
      };
    },


    passwordUsuario: function () {
      this.errors = null;
      this.$store.commit("setLoading", true);
      this.editData.permissions = this.getPermisions();
      if (this.editData.password !== this.editData.password_confirmation) {
        this.errors = {
          error: "Ocurrió un error",
          errors: { password_confirmation: ["Los passwords no coinciden."] },
        };
        this.$store.commit("setLoading", false);
        return false;
      }
      const userId = this.editData.id_usuario || this.editData.id;
      axios
        .post(process.env.VUE_APP_API_URL + "usuario/password", {
          id: userId,
          id_usuario: userId,
          password: this.editData.password,
        })
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data;
          } else {
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getUsuariosBusqueda();
        });
    },

    closeModal() {
      this.showModal = false;
      this.operation = null;
      this.filtroTextoPermiso = "";
      this.filtroTextoIntegrador = "";
    },
  },
};
</script>

<style scoped>
.permissions-tree {
  font-size: 0.9rem;
}
.tree-header-app {
  background-color: #f8f9fa;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.15s ease-in-out;
}
.tree-header-app:hover {
  background-color: #e9ecef;
}
.tree-permiso-leaf {
  transition: background-color 0.12s ease-in-out;
  border-bottom: 1px dashed #eef0f2;
}
.tree-permiso-leaf:hover {
  background-color: #f8f9fa;
}
.custom-checkbox .custom-control-label {
  cursor: pointer;
}
</style>
